import React from 'react';
import {Colors, FontStyles, Routes} from "../constants";
import StoryGridView from "./story_grid_view";
import Dialog from "components/dialog/dialog_view";
import {dbStories, auth, dbShared} from "components/firebase";
import {Span} from "components/common_style/text";
import {TextInput} from "components/common_style/text_input";
import {Flex} from "components/common_style/flex";
import {Button} from "components/common_style/button";
import {ReactComponent as Plus} from "../../assets/icons/plus_shape.svg";
import styled from "styled-components";
import {ReactComponent as Delete} from "../../assets/icons/close.svg";
import PrintStory from "components/print_story";
import * as Localizations from "react-dnd";
import {Localization} from "localizations/languages";

const SharedBadgeFrame = styled.span`
${FontStyles.button};
border-radius: 10px;
padding: 5px;
height: 22px;
background-color: rgba(255, 255, 255, 0.8);
margin: 5px;
display: flex;
cursor: pointer;
`;

const FlexNoScrollbar = styled(Flex)`
-ms-overflow-style: none;  /* Internet Explorer 10+ */
scrollbar-width: none;  /* Firefox */

::-webkit-scrollbar {
display: none;  /* Safari and Chrome */
}
`;

class StoryGrid extends React.Component {
    constructor(props) {
        super(props);
        this.subscriptions = [];
        this.state = {
            showDeleteDialog: false,
            showShareDialog: false,
            showPrintDialog: false,
            printStory: null,
            stories: []
        };
        this._fetchData();
    }

    async _fetchData() {
        if (this.props.shared) {
            let stories = [];
            let sharedFrom = {};
            let docs = await dbShared.where('to', '==', StoryGrid.formatShareMail(auth.currentUser.email)).get();
            let n_done = 0;
            let to_do = docs.docs.length;
            docs.docs.forEach(d => {
                let unsub = d.data().story.onSnapshot(story => {
                    stories.push(story);
                    sharedFrom[story.uuid] = d.data().from || 'unknown user';
                    unsub();
                    n_done++;
                    if (n_done === to_do) {
                        this.setState({
                            stories: stories.sort((a, b) => a.data().ts > b.data().ts ? 1 : -1),
                            sharedFrom: sharedFrom
                        });
                    }
                })
            });
        } else {
            let unsubscribe = dbStories
                .where('owner', '==', auth.currentUser.uid)
                .onSnapshot(snapshot => {
                    this.setState({
                        stories: snapshot.docs.sort((a, b) => a.data().ts > b.data().ts ? 1 : -1),
                    });
                });

            this.subscriptions.push(unsubscribe);
        }

    }

    static formatShareMail(mail) {
        return mail.split(' ').join('').toLowerCase()
    }

    componentWillUnmount() {
        this.subscriptions.forEach(u => u());
    }

    _onStoryClick(story, edit) {
        if (edit) {
            this.props.history.push(Routes.storyEditor + '#' + story.id);
        } else {
            this.props.history.push(Routes.storyViewer + '#' + story.id);
        }
    }

    async _onNewStory() {
        let newstory = await dbStories.add({
            owner: auth.currentUser.uid,
            title: Localization.current.translation1,
            ts: new Date().getTime()
        });
        let sub = newstory.onSnapshot(() => {
            this.props.history.push(Routes.storyEditorTitle + '#' + newstory.id);
            sub();
        });
    }

    static getSharedBadge(mail, onDelete) {
        return <SharedBadgeFrame onClick={() => onDelete()}>
            {mail}<Delete style={{fill: Colors.button, width: 20, height: 20, margin: 1, marginLeft: 5}}/>
        </SharedBadgeFrame>
    }

    render() {
        return <Flex column>
            {this.props.shared ? null : <Button onClick={() => this._onNewStory()} style={{
                width: 200,
                height: 40,
                marginTop: 60,
                marginBottom: 30,
                marginRight: 30,
                marginLeft: 'auto'
            }}>{Localization.current.translation39}</Button>}
            <StoryGridView stories={this.state.stories} onNewStory={() => this._onNewStory()}
                           shared={this.props.shared}
                           sharedFrom={this.state.sharedFrom}
                           onDelete={(story) => this._onDeleteStory(story)}
                           onPdf={(story) => this.exportPdf(story)}
                           onShare={(story) => this._onShareStory(story)}
                           onStoryClick={(story) => this._onStoryClick(story, false)}
                           onEdit={(story) => this._onStoryClick(story, true)}>
                {this.state.showDeleteDialog ?
                    <Dialog confirm={Localization.current.translation57} cancel={Localization.current.translation56}
                            onCancel={() => this.onCancel()}
                            onConfirm={() => this.onDelete()}>
                        <Span textStyle={FontStyles.titleBold}>
                            {Localization.current.translation40}
                        </Span>
                        <Span textStyle={FontStyles.body} center>{Localization.current.translation55}</Span>
                    </Dialog> : null}
                {this.state.showShareDialog ?
                    <Dialog confirm={Localization.current.translation11} onConfirm={() => this.onCancel()}>
                        <Span textStyle={FontStyles.titleBold}>
                            {Localization.current.translation9}
                        </Span>
                        <Flex vAlign={'flex-end'}>
                            <TextInput id={"email"} label={Localization.current.translation58} name={'email'} autoComplete={'e-mail'}
                                       style={{marginTop: 30, marginBottom: 20}}/>
                            <Button onClick={(e) => {
                                e.preventDefault();
                                let elem = document.getElementById('email');
                                let val = elem.value + '';
                                elem.value = '';
                                this.onShare(val);
                            }} width={60} height={52} style={{marginBottom: 20, borderRadius: 0}}><Plus
                                style={{fill: 'white'}}/></Button>
                        </Flex>
                        <FlexNoScrollbar wmax wrap hAlign={'center'} style={{
                            marginBottom: 20,
                            height: 82,
                            overflowY: 'scroll',
                        }}>{!!this.state.sharedWith ? this.state.sharedWith.map((email, i) => StoryGrid.getSharedBadge(email, () => this.removeShared(this.activeStory, i))) : null}</FlexNoScrollbar>
                    </Dialog> : null}
                {this.state.showPrintDialog ? <Dialog confirm={'CANCEL'} onConfirm={() => this.onCancel()}>
                    <PrintStory
                        generatingView={(done, total) => <Span
                            textStyle={FontStyles.titleBold}>{Localization.current.translation41} {done} {Localization.current.translation42} {total}.</Span>}
                        onDone={() => this.onCancel()}
                        storyDoc={this.state.printStory}/>
                    <div style={{height: 50}}/>
                </Dialog> : null}

            </StoryGridView>
        </Flex>
    }

    onCancel() {
        this.setState({
            showDeleteDialog: false,
            showShareDialog: false,
            showPrintDialog: false,
        });
    }

    async onDelete() {
        let docs = await dbShared.where('story', '==', this.activeStory.ref).get();
        docs.docs.forEach((d) => {
            d.ref.delete();
        });
        await dbStories.doc(this.activeStory.id).delete();
        this.activeStory = undefined;
        this._fetchData();
        this.setState({showDeleteDialog: false});
    }


    async _onShareStory(story) {
        this.activeStory = story;
        this.setState({
            showShareDialog: true,
            sharedWith: story.data().sharedWith || []
        });
    }

    async exportPdf(story) {
        this.setState({
            showPrintDialog: true,
            printStory: story,
        })
    }

    async _onDeleteStory(story) {
        this.activeStory = story;
        this.setState({showDeleteDialog: true});
    }

    static sharedId(mail) {
        return auth.currentUser.uid + '_' + mail;
    }

    async onShare(mail) {
        if (!mail) return;
        if (!mail.includes('@')) {
            mail += '@micreate.eu';
        }
        mail = StoryGrid.formatShareMail(mail);
        let mails = this.state.sharedWith;
        mails.push(mail);
        await dbStories.doc(this.activeStory.id).update({
            sharedWith: mails
        });
        await dbShared.doc(StoryGrid.sharedId(mail)).set({
            owner: auth.currentUser.uid,
            from: auth.currentUser.email,
            to: mail,
            story: dbStories.doc(this.activeStory.id)
        });
        this.setState({
            sharedWith: mails
        });
        console.log(mails);
    }

    async removeShared(activeStory, i) {
        console.log(activeStory.id, i);
        let mails = this.state.sharedWith;
        let remove_mail = mails.splice(i, 1);
        try {
            await dbShared.doc(StoryGrid.sharedId(remove_mail)).delete();
        } catch (e) {
            console.log(e);
        }
        await dbStories.doc(this.activeStory.id).update({
            sharedWith: mails
        });
        this.setState({
            sharedWith: mails
        });
        console.log(mails);
    }
}

export default StoryGrid;
